export const ActionType = {
    VIEW : 'View',
    ADD : 'Add',
}
export const FirmOwnershipType = {
    PROPRIETORSHIP : 'Proprietorship',
    HINDU_UNDIVIDED_FAMILY : 'Hindu Undivided Family',
    PARTNERSHIP : 'Partnership',
    LIMITED_LIABILITY_PARTNERSHIP : 'Limited Liability Partnership',
    PRIVATE_LIMITED_COMPANY : 'Private Limited Company',
    PUBLIC_LIMITED_COMPANY : 'Public Limited Company',
}
export const InsuranceType = {
    LIFE_INSURANCE : "Life Insurance",
    MEDICAL_INSURANCE : "Medical Insurance",
    STAFF_INSURANCE : "Staff Insurance (PA Cover)",
    SHOP_INSURANCE : "Shop Insurance",
    ANNUAL_TOUR : "Annual Tour",
    GAP_BENEFIT : "Golden Age Plan",
    OTHER : "Other"
}
export const AccountType = {
    SAVINGS: "Savings",
    CURRENT: "Current"
};

export const BankVerificationStatus = {
  VERIFIED: { label: "Verified", color: "green" },
  NOT_VERIFIED: { label: "Not verified", color: "gray" },
  PENDING: { label: "Pending", color: "orange" },
};